import "./CardsList.scss";

export default (props) => {
  return <div className="Cards-list">{props.children}</div>;
};
